<template>
  <div class="home">
    <div>
      <div class="nav-bkg">

          <ul class="dash-nav">
            <li style="font-size:18px;"><router-link class="link" to="/open">Open</router-link></li>
            <li style="font-size:18px;"><router-link class="link" to="/closed">Closed</router-link></li>
            <li style="font-size:18px;"><router-link class="link" to="/customers">Customers</router-link></li>
            <!-- <li><router-link class="link" to="/marketing">Marketing</router-link></li> -->
          </ul>

      </div>
    </div>
    <!-- <Table class="mt-5"/> -->
    <router-view class="view-tables" />
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "@/components/Table.vue";

export default {
  name: "home",
  components: {
    Table
  }
};
</script>

<style scoped>
  .home {
    margin-top: 50px;
  }
  .nav-bkg {
    position: fixed;
    width: 100vw;
    /* background-color: #e96262; */
    background-color: #DA2a2a;
    padding: 30px 5px 1px 5px;
    z-index: 2;
  }

  .dash-nav {
    text-decoration: none;
    text-align: start;
  }

  .dash-nav li {
    display: inline;
    padding: 10px;
  }

  .link {
    color: #ffffff;
    font-weight: 600;
  }

  .view-tables {
    padding-top: 70px;
  }
</style>
